import { AdminTransactionFees } from "Components/Dashboard/TransactionFees/AdminTransactionFees";
import { HunterTransactionFees } from "Components/Dashboard/TransactionFees/HunterTransactionFees";
import { MerchantTransactionFees } from "Components/Dashboard/TransactionFees/MerchantTransactionFees";
import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { AccessRoleCodes, type AccessRoleCode } from "Models/AccessRoleCodes";
import type { ReactElement } from "react";

const USER_ROLE_TO_TRANSACTION_FEES: Record<
  AccessRoleCode,
  ReactElement | null
> = {
  [AccessRoleCodes.Merchant]: <MerchantTransactionFees />,
  [AccessRoleCodes.Hunter]: <HunterTransactionFees />,
  [AccessRoleCodes.Admin]: <AdminTransactionFees />,
  [AccessRoleCodes.AdminLite]: <AdminTransactionFees />,
  [AccessRoleCodes.Aml]: null,
  [AccessRoleCodes.Customer]: null,
  [AccessRoleCodes.Employee]: null,
  [AccessRoleCodes.CustomerOnboarding]: null,
  [AccessRoleCodes.HunterPlus]: <HunterTransactionFees />,
  [AccessRoleCodes.Disponent]: null,
  [AccessRoleCodes.Child]: null,
};

export const TransactionFees = (): ReactElement | null => {
  const userRole = useCurrentUserRole();

  if (!userRole) {
    return null;
  }

  return USER_ROLE_TO_TRANSACTION_FEES[userRole];
};
